window.renderRecommendedForLastViewedProduct = async function renderRecommendedForLastViewedProduct() {
  const container = document.querySelector('.recommended-products');
  if (!container) return;

  // SWIPER HOST — If .recommended-swiper exists, use its .swiper-wrapper
  const swiperRoot = document.querySelector('.relatedSlider');
  const slideHost = document.querySelector('.recommended-products');
  const recommendationsWrapper = document.querySelector(
    '.cart-drawer-recommendations-wrapper'
  );


  // LOADING STATE
const sliderWrapper = swiperRoot;
sliderWrapper?.classList.add('is-loading');

  slideHost.innerHTML = '<p>Loading...</p>';

  try {
    // 1. Get Latest Cart Item
    const cart = await fetch('/cart.js').then(r => r.ok ? r.json() : null);
    const latestItem = cart?.items?.[0];

    if (!latestItem?.product_id) {
      recommendationsWrapper?.classList.add('hidden');
      slideHost.innerHTML = '<p>No recent cart item.</p>';
      sliderWrapper?.classList.remove('is-loading');
      return;
    }

    // 2. Get Shopify Recommendations
    const recUrl = `/recommendations/products.json?product_id=${latestItem.product_id}&limit=12`;
    const rec = await fetch(recUrl).then(r => r.ok ? r.json() : { products: [] });
    const recs = Array.isArray(rec.products) ? rec.products : [];

    if (!recs.length) {
      recommendationsWrapper?.classList.add('hidden');
      slideHost.innerHTML = '<p>No recommendations available.</p>';
      sliderWrapper?.classList.remove('is-loading');
      swiperRoot?.querySelectorAll('.swiper-button-next, .swiper-button-prev')
      .forEach(btn => btn.style.display = 'none');
      return;
    }

    // 3. Render Cards
    recommendationsWrapper?.classList.remove('hidden');

    slideHost.innerHTML = recs.map(p => createProductHtml(p)).join('');

    // 4. Append QuickAdd Modals
    const modalContainer = document.getElementById('dynamic-quick-add-modals');
    if (!modalContainer) {
      console.warn('Dynamic quick add modals container missing!');
    } else {
      recs.forEach(p => {
        const modalId = `QuickAdd-${p.id}`;
        const modalHtml = `
          <quick-add-modal id="${modalId}" class="quick-add-modal">
            <div role="dialog" aria-label="Choose options for ${p.title}"
              aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">

              <button id="ModalClose-${p.id}" type="button" class="quick-add-modal__toggle" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
                  <path fill="currentColor"
                    d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z">
                  </path>
                </svg>
              </button>

              <div id="QuickAddInfo-${p.id}" class="quick-add-modal__content-info"></div>
            </div>
          </quick-add-modal>
        `;
        modalContainer.insertAdjacentHTML('beforeend', modalHtml);
      });
    }

    // 5. Re-initialise DAWN QuickAdd
    if (window.QuickAddModal) {
      document.querySelectorAll('[data-open-quick-add]').forEach(btn => {
        new window.QuickAddModal(btn);
      });
    } else if (window.Shopify?.theme?.sections?.registered) {
      document.dispatchEvent(new CustomEvent('shopify:section:load'));
    }

    // 6. INITIALIZE SWIPER NOW THAT PRODUCTS ARE LOADED
    if (swiperRoot) {
      // Destroy existing instance
      if (swiperRoot.swiper && typeof swiperRoot.swiper.destroy === 'function') {
        swiperRoot.swiper.destroy(true, true);
      }
      if (window.recommendedSwiper && typeof window.recommendedSwiper.destroy === 'function') {
        window.recommendedSwiper.destroy(true, true);
      }

      // Create new Swiper
      window.recommendedSwiper = new Swiper(swiperRoot, {
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
          nextEl: swiperRoot.querySelector('.swiper-button-next'),
          prevEl: swiperRoot.querySelector('.swiper-button-prev'),
        },
        watchOverflow: true,
        // breakpoints: {
        //   0:  { slidesPerView: 1 },
        //   640:{ slidesPerView: 2 },
        //   1024:{ slidesPerView: 3 }
        // }
      });
    }

    sliderWrapper?.classList.remove('is-loading');

  } catch (e) {
    console.error('renderRecommendedForLastViewedProduct error', e);
    slideHost.innerHTML = '<p>Failed to load recommendations.</p>';
    sliderWrapper?.classList.remove('is-loading');
  }
};


// // ------------------------------------------------------------
// // 1. MAIN RECOMMENDATION RENDERER 
// // ------------------------------------------------------------
// window.renderRecommendedForLastViewedProduct = async function renderRecommendedForLastViewedProduct() {
//   const container = document.querySelector('.recommended-products');
//   if (!container) return;

//   // Use the container itself as the host 
//   const slideHost = container;
//   slideHost.innerHTML = '<p>Loading...</p>';

//   try {
//     // ---- 1. Get latest cart item -------------------------------------------------
//     const cart = await fetch('/cart.js').then(r => r.ok ? r.json() : null);
//     const latestItem = cart?.items?.[0];
//     if (!latestItem?.product_id) {
//       slideHost.innerHTML = '<p>No recent cart item.</p>';
//       return;
//     }

//     // ---- 2. Shopify recommendations ------------------------------------------------
//     const recUrl = `/recommendations/products.json?product_id=${latestItem.product_id}&limit=12`;
//     const rec = await fetch(recUrl).then(r => r.ok ? r.json() : { products: [] });
//     const recs = Array.isArray(rec.products) ? rec.products : [];

//     if (!recs.length) {
//       slideHost.innerHTML = '<p>No recommendations available.</p>';
//       return;
//     }

//     // ---- 3. Render cards -----------------------------------------------------------

//     slideHost.innerHTML = recs.map(p => createProductHtml(p)).join('');
   


// // 4. Append QuickAdd modals at bottom container
//     const modalContainer = document.getElementById('dynamic-quick-add-modals');

// recs.forEach(p => {
//   const modalId = `QuickAdd-${p.id}`;
//   const modalHtml = `
//     <quick-add-modal id="${modalId}" class="quick-add-modal">
//       <div role="dialog" aria-label="Choose options for ${p.title}"
//         aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">

//         <button id="ModalClose-${p.id}" type="button" class="quick-add-modal__toggle" aria-label="Close">
//         <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
//           </svg>
//         </button>

//         <div id="QuickAddInfo-${p.id}" class="quick-add-modal__content-info"></div>
//       </div>
//     </quick-add-modal>
//   `;

//   modalContainer.insertAdjacentHTML('beforeend', modalHtml);
// });


//     // ---- 4. Re-initialise Dawn Quick-Add (v10+) ------------------------------------
//     if (window.QuickAddModal) {
//       document.querySelectorAll('[data-open-quick-add]').forEach(btn => {
//         new window.QuickAddModal(btn);
//       });
//     } else if (window.Shopify?.theme?.sections?.registered) {
//       // older Dawn fallback
//       document.dispatchEvent(new CustomEvent('shopify:section:load'));
//     }
    



//   } catch (e) {
//     console.error('renderRecommendedForLastViewedProduct error', e);
//     slideHost.innerHTML = '<p>Failed to load recommendations.</p>';
//   }
// };



// ------------------------------------------------------------
// 2. CARD BUILDER (quick-add modal instead of add-to-cart)
// ------------------------------------------------------------
function createProductHtml(product) {
  const variants = Array.isArray(product.variants) ? product.variants : [];
  const variantCount = variants.length;
  const variant = variants[0] ?? null;

  const reviewAverage = product.metafields?.['app--2519111--reviews']?.review_average_rating;
  const reviewWrapperClass = reviewAverage ? 'has-review' : 'no-review';

  const modalId = `QuickAdd-${product.id}`;
  const openerId = `quick-add-opener-${product.id}`;

  // ----- QUICK-ADD LOGIC -----
  const hasQtyRules = variant
    ? (variant.quantity_rule?.min > 1 ||
       variant.quantity_rule?.max != null ||
       variant.quantity_rule?.increment > 1)
    : false;

  const needsModal = variantCount > 1 || hasQtyRules;

  let quickAddHtml = '';

  if (needsModal) {
    // ----- MULTI-VARIANT → modal -----
    quickAddHtml = `
     <modal-opener data-modal="#${modalId}">
  <button
    id="${openerId}"
    type="button"
    class="quick-add__submit button button--full-width button--secondary"
    aria-haspopup="dialog"
    data-product-url="${product.url}"
    data-open-quick-add
  >
    Quick View
   <div class="loading__spinner hidden">
  <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

</div>
  </button>
</modal-opener>

   `;
  } else {
    // ----- SINGLE VARIANT → direct add -----
    const disabled = !variant?.available ? 'disabled' : '';
    quickAddHtml = `
      <product-form>
        <form method="post" action="/cart/add" class="form" novalidate data-type="add-to-cart-form">
          <input type="hidden" name="id" value="${variant?.id ?? ''}" ${disabled}>
          <button type="submit" class="quick-add__submit button button--full-width button--secondary" ${disabled}>
            <span>${variant?.available ? 'Add to Cart' : 'Sold Out'}</span>
            <span class="sold-out-message hidden">Sold Out</span>
            <span class="loading-spinner hidden"></span>
          </button>
        </form>
      </product-form>`;
  }

  // ----- CARD MARKUP  -----
  return `
  <div class="swiper-slide">
    <div class="trending-content product-card">
      <div class="card-drawer-product-card">
        <div class="cart-drawer-card-top">
          <a class="trending-product-img" href="${product.url}">
            <div class="media" style="--imageRatio:${
              product.featured_media?.preview_image?.aspect_ratio
                ? (1 / product.featured_media.preview_image.aspect_ratio * 100) + '%'
                : '100%'
            };">
              <img src="${product.featured_image || (product.images?.[0] ?? '')}"
                   alt="${product.title}" loading="lazy" />
            </div>
          </a>

          <div class="trending-product-detail">
        

            <a href="${product.url}" class="product-title">${product.title}</a>
          </div>
        </div>

        <div class="cart-drawer-card-bottom">
          <div class="price">£${(product.price / 100).toFixed(2)}</div>

          <div class="quick-add no-js-hidden">
            ${quickAddHtml}
          </div>
        </div>
      </div>
      </div>
    </div>`;
}

    // <div class="review-badge-wrapper">
    //           <a href="${product.url}#yotpo-app">
    //             <div class="yotpo-widget-instance ${reviewWrapperClass}"
    //                  data-yotpo-instance-id="361637"
    //                  data-yotpo-product-id="${product.id}"
    //                  data-yotpo-cart-product-id="${variant?.id ?? ''}"
    //                  data-yotpo-section-id="collection"></div>
    //           </a>
    //         </div>